import setSliderSettings from '../../js/components/slider.js';

( () => {

	/**
	 * Block name
	 *
	 * @type {string}
	 */
	const blockName = 'latest-events';

	/**
	 * Init
	 */
	window.addEventListener( 'load', () => {

		const blocks = document.querySelectorAll( `.block-${ blockName }` );
		if ( blocks.length > 0 ) {

			blocks.forEach( ( block ) => {

				initializeBlock( block );

			} );

		}

	} );

	/**
	 * Initialize slider
	 *
	 * @param {object} block
	 */
	const initSlider = ( block ) => {

		const slider = block.querySelector( '.wombat-slider-container' );
		// inititalize slider
		if ( slider ) {

			setSliderSettings( slider );

		}

	}

	/**
	 * Block init
	 *
	 * @param {object} block
	 */
	const initializeBlock = ( block ) => {

		if ( block[ 0 ] !== undefined ) {

			block = block[ 0 ].querySelector( `.block-${ blockName }` );

		}
		if ( block === false || block === null ) {}

		// Block Code Here
		initSlider( block );

	};

} )();
